import React from "react";
import { gql } from "@apollo/client";
import { apolloClient } from "../../..";
import dateFormat from "dateformat";
import { notify } from "../../Notify/Notify";
import ReminderCount from "./ReminderCount/ReminderCount";
import Reminder from "./Reminder/Reminder";
import EmptyStates from "../../EmptyStates/EmptyStates";
import emptyReminderImage from "../../../assets/EmptyStates/empty_reminder.svg";
import UseAnimations from "react-useanimations";
import loadingIcon from "react-useanimations/lib/loading";

// Styles
import "./Reminders.scss";

const Reminders = ({ handleDocumentView }) => {
  const [reminders, setReminders] = React.useState();
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    const date = new Date();
    let startDate = dateFormat(
      new Date(dateFormat(date, "yyyy"), dateFormat(date, "mm") - 1, dateFormat(date, "dd")),
      "yyyy-mm-dd"
    );
    let endDate = dateFormat(
      new Date(dateFormat(date, "yyyy"), dateFormat(date, "mm") - 1, parseInt(dateFormat(date, "dd")) + 5),
      "yyyy-mm-dd"
    );

    const variables = {
      startDate: startDate,
      endDate: endDate,
    };
    apolloClient
      .query({
        query: gql`
          query allEventsBetweenDates($startDate: String!, $endDate: String!) {
            allEventsBetweenDates(startDate: $startDate, endDate: $endDate) {
              id
              documentId
              documentTitle
              documentDescription
              dateTitle
              dateDescription
              documentDate
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        setReminders(result.data.allEventsBetweenDates);
        setIsLoading(false);
      })
      .catch((e) => {
        setIsLoading(false);
        const title = "Error";
        const detail = "oops! Something went wrong";
        const type = "error";
        notify(title, detail, type);
      });
  }, []);

  return (
    <div className="reminders">
      <div className="header">
        <h5 className="bold">Reminders</h5>
        <ReminderCount {...{ reminders }} />
      </div>
      {isLoading ? (
        <div className="loading-state-container">
          <UseAnimations
            className="loading-icon"
            animation={loadingIcon}
            autoplay={true}
            loop={true}
            strokeColor="Black"
            size={40}
          />
        </div>
      ) : reminders ? (
        reminders.length === 0 ? (
          <div className="empty-state-container">
            <EmptyStates imgSrc={emptyReminderImage} emptyStateTitle="You are up-to-date" emptyStateButtons={[]} />
          </div>
        ) : (
          <div className="reminder-list">
            {reminders.map((reminder) => <Reminder key={reminder.id} {...{ reminder, handleDocumentView }} />)}
          </div>
        )
      ) : null}
    </div>
  );
};

export default Reminders;
